import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { TurnoverConfigurationEffects } from '@main-application/management/pages/turnover-configuration/store/effects/turnover-configuration.effects';

import * as fromTurnoverConfiguration from './reducers';

@NgModule({
  declarations: [],
  imports: [
    StoreModule.forFeature(
      fromTurnoverConfiguration.turnoverConfigurationFeatureKey,
      fromTurnoverConfiguration.reducer
    ),
    EffectsModule.forFeature([TurnoverConfigurationEffects]),
  ],
})
export class TurnoverConfigurationStoreModule {}
